export default function StatusChip({ status }) {
  const map = {
    available: ["Available", "bg-emerald-100 text-emerald-700"],
    blocked: ["Blocked", "bg-amber-100 text-amber-700"],
    on_test_drive: ["On Test Drive", "bg-blue-100 text-blue-700"],
    workshop: ["Workshop", "bg-red-100 text-red-700"],
    grounded: ["Grounded", "bg-slate-200 text-slate-600"],
    in_transit: ["In Transit", "bg-indigo-100 text-indigo-700"],
    pending_approval: ["Pending Approval", "bg-amber-100 text-amber-700"],
    approved: ["Approved", "bg-emerald-100 text-emerald-700"],
    completed: ["Completed", "bg-slate-100 text-slate-600"],
    rejected: ["Rejected", "bg-red-100 text-red-700"],
    expired: ["Expired", "bg-slate-100 text-slate-500"],
    released: ["Released", "bg-slate-100 text-slate-500"],
    started: ["Trip Started", "bg-indigo-100 text-indigo-700"],
    gate_out: ["On Test Drive", "bg-blue-100 text-blue-700"],
    gate_in: ["Gated In", "bg-teal-100 text-teal-700"],
    closed: ["Closed", "bg-slate-100 text-slate-600"],
    open: ["In Workshop", "bg-red-100 text-red-700"],
    reported: ["Reported", "bg-amber-100 text-amber-700"],
    with_accounts: ["With Accounts", "bg-fuchsia-100 text-fuchsia-700"],
    sold: ["Sold", "bg-slate-700 text-white"],
    retired: ["Retired", "bg-slate-300 text-slate-700"],
    pending_vp_approval: ["Pending VP", "bg-amber-100 text-amber-700"],
    pending_sm_approval: ["Pending SM", "bg-amber-100 text-amber-700"],
    slot_missed: ["Slot Missed", "bg-red-100 text-red-700"],
  };
  const [label, cls] = map[status] || [status, "bg-slate-100 text-slate-600"];
  return (
    <span data-testid={`status-chip-${status}`} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`}>
      {label}
    </span>
  );
}
